import { useEffect } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';

import { BuyNowInitializer } from '@ctct/application-layer';
import { PayflowTopBarWidget, usePayflowTopBarWidget } from '@ctct/react-app-layer';
import { useBuyNowPageStore } from '@ctct/state-client-layer';

import { BuyNowPage } from './BuyNowPage';
import { BuyNowThankYouPage } from './BuyNowThankYouPage';

const initializer = new BuyNowInitializer();

export const BuyNow = () => {
  const { path } = useRouteMatch();

  useEffect(() => {
    initializer.listeners.on();

    return () => initializer.listeners.off();
  }, []);

  const payflowTopBarWidget = usePayflowTopBarWidget({
    initializer,
    pageStore: useBuyNowPageStore,
  });

  return (
    <>
      <PayflowTopBarWidget {...payflowTopBarWidget} />
      <Switch>
        <Route exact path={path}>
          <BuyNowPage initializer={initializer} />
        </Route>
        <Route exact path={`${path}/thank-you`}>
          <BuyNowThankYouPage initializer={initializer} />
        </Route>
      </Switch>
    </>
  );
};
